import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import axios from 'axios';

import { url } from '../utils/config';
import { toast } from 'react-toastify';
import Button from '../reusable_components/Button';
import { btnOne, inputStyle, title } from '../utils/style';
import AddGeneralEquipmentItem from '../modals/AddGeneralEquipmentItem';
import generalEquipmentItems from '../atoms/generalEquipmentItems';


function GeneralEquipment() {
    const [showAddForm, setShowAddForm] = useState(false);
    const [equipments, setEquipments] = useState({});
    const [items, setItems] = useRecoilState(generalEquipmentItems)
    const [reloadTable, setReloadTable] = useState(false)
    const navigate = useNavigate();


    useEffect(() => { fetchEquipments() }, [reloadTable])



    async function fetchEquipments() {
        try {
            const reqUrl = url + '/general_equipments_list';
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data } = await axios.get(reqUrl, { headers });
            console.log(data)
            setEquipments(data);
        } catch (error) {
            toast.error(error.response.data.message, { autoClose: 3000 })
        }

    }

    async function fetchEquipmentItems(general_equipment_id) {
        try {
            const reqUrl = url + '/general_equipment_items/' + general_equipment_id;
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const data = await axios.get(reqUrl, { headers });
            console.log(data.data);
            setItems(data.data);
            navigate('/general_equipments/items');
        } catch (error) {
            toast.error(error.response.data.message, { autoClose: 3000 })
        }

    }

    // function filterEquipmentList() {
    //     const data = equipments.equipmentsList.filter(eq => eq.specialEquipment_id === equipments.specialEquipments[equipmentIndex]['id']);
    //     setInfo(data);
    //     navigate('/special_equipments/info')
    // }



    return (
        <div className='pt-10'>
            <div className={title}>General Equipment</div>
            {
                showAddForm ? <AddGeneralEquipmentItem setShowAddForm={setShowAddForm} reload={setReloadTable} equipments={equipments} /> : null
            }
            <div className=" flex justify-between items-center py-4 pr-16">
                <div className='basis-1/3 justify-left'>
                    <input className={inputStyle} placeholder="Search Equipment" />
                </div>
                <div className='flex justify-end'>
                    <Button className={btnOne} name={'Add Equipment'} clickHandler={() => setShowAddForm(!showAddForm)} />
                </div>
            </div>
            <div className="grid grid-cols-5 gap-5">
                {equipments?.specialEquipments &&
                    equipments.specialEquipments.map((equipment, index) => (
                        <div
                            key={index}
                            className="shadow-lg p-4 bg-white flex flex-col items-center rounded-xl transition-transform duration-300 hover:scale-105"
                        >
                            <div className="flex">
                                <img
                                    onClick={() => fetchEquipmentItems(equipment.id)}
                                    src={`${url}/${equipment.imageUrl}`}
                                    alt={equipment.name}
                                    className="cursor-pointer h-40 w-48 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300"
                                />
                            </div>
                            <div className="text-md font-semibold py-2 text-gray-800 text-center">
                                {equipment.name}
                            </div>
                        </div>
                    ))}
            </div>

        </div>
    )

}
export default GeneralEquipment;